import { tokens } from '@airtel/air-design-system';
import { StyleSheet } from 'react-native';
export var getSchedulingSlotListStyles = isLargeScreen => {
  return StyleSheet.create({
    container: Object.assign({
      display: 'flex'
    }, isLargeScreen && {
      flexDirection: 'row',
      flexWrap: 'wrap'
    }),
    singleSlotItem: {
      width: !isLargeScreen && '100%',
      marginRight: isLargeScreen ? tokens.spacing.SPACING_16 : tokens.spacing.SPACING_0
    },
    singleSlotItemBottomSpacing: {
      marginBottom: tokens.spacing.SPACING_8
    }
  });
};